// Same React app, two domains — greenwich.am (Armenia, default) and
// fr.greenwich.am (France). MARKET is resolved once from the hostname at load
// time, no build-time flag or separate deploy needed: both Railway frontend
// services run this exact same code, only their attached domain differs.
// See greenwich-backend/server.js's Program.market field for the matching
// backend-side concept (programs already filter by market; this is step one
// of extending that to the rest of the app — Feed/Community/Buddy/etc. — per
// the France-separation plan).
const FRANCE_HOSTNAME_PREFIXES = ['fr.', 'www.fr.'];

function detectMarket() {
  if (typeof window === 'undefined' || !window.location) return 'AM';
  const host = window.location.hostname.toLowerCase();
  if (FRANCE_HOSTNAME_PREFIXES.some((prefix) => host.startsWith(prefix))) return 'FR';
  return 'AM';
}

export const MARKET = detectMarket();
export const IS_FRANCE_MARKET = MARKET === 'FR';
